import styled from 'styled-components';

export const WelcomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  align-items: center;
  background: ${({ theme }) =>
    theme.colors
      .oxfordBlueDark}; // spoke to Rafael - leave it like that for now
`;

export const WelcomeContent = styled.div``;

export const TopSection = styled.div`
  margin-top: 156px;
`;

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 90px;
  gap: ${({ theme }) => theme.spacing.xm};
  h3 {
    font-size: ${({ theme }) => theme.fontSize.s};
    font-family: Source Sans Pro;
  }
`;
